var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.users),function(user,i){return _c('single-profile',{key:i,attrs:{"userData":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }